"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currencies = void 0;
var Currencies;
(function (Currencies) {
    Currencies["AED"] = "AED";
    Currencies["AFN"] = "AFN";
    Currencies["ALL"] = "ALL";
    Currencies["AMD"] = "AMD";
    Currencies["ANG"] = "ANG";
    Currencies["AOA"] = "AOA";
    Currencies["ARS"] = "ARS";
    Currencies["AUD"] = "AUD";
    Currencies["AWG"] = "AWG";
    Currencies["AZN"] = "AZN";
    Currencies["BAM"] = "BAM";
    Currencies["BBD"] = "BBD";
    Currencies["BDT"] = "BDT";
    Currencies["BGN"] = "BGN";
    Currencies["BHD"] = "BHD";
    Currencies["BIF"] = "BIF";
    Currencies["BMD"] = "BMD";
    Currencies["BND"] = "BND";
    Currencies["BOB"] = "BOB";
    Currencies["BOV"] = "BOV";
    Currencies["BRL"] = "BRL";
    Currencies["BSD"] = "BSD";
    Currencies["BTN"] = "BTN";
    Currencies["BWP"] = "BWP";
    Currencies["BYN"] = "BYN";
    Currencies["BZD"] = "BZD";
    Currencies["CAD"] = "CAD";
    Currencies["CDF"] = "CDF";
    Currencies["CHE"] = "CHE";
    Currencies["CHF"] = "CHF";
    Currencies["CHW"] = "CHW";
    Currencies["CLF"] = "CLF";
    Currencies["CLP"] = "CLP";
    Currencies["CNY"] = "CNY";
    Currencies["COP"] = "COP";
    Currencies["COU"] = "COU";
    Currencies["CRC"] = "CRC";
    Currencies["CUC"] = "CUC";
    Currencies["CUP"] = "CUP";
    Currencies["CVE"] = "CVE";
    Currencies["CZK"] = "CZK";
    Currencies["DJF"] = "DJF";
    Currencies["DKK"] = "DKK";
    Currencies["DOP"] = "DOP";
    Currencies["DZD"] = "DZD";
    Currencies["EGP"] = "EGP";
    Currencies["ERN"] = "ERN";
    Currencies["ETB"] = "ETB";
    Currencies["EUR"] = "EUR";
    Currencies["FJD"] = "FJD";
    Currencies["FKP"] = "FKP";
    Currencies["GBP"] = "GBP";
    Currencies["GEL"] = "GEL";
    Currencies["GHS"] = "GHS";
    Currencies["GIP"] = "GIP";
    Currencies["GMD"] = "GMD";
    Currencies["GNF"] = "GNF";
    Currencies["GTQ"] = "GTQ";
    Currencies["GYD"] = "GYD";
    Currencies["HKD"] = "HKD";
    Currencies["HNL"] = "HNL";
    Currencies["HRK"] = "HRK";
    Currencies["HTG"] = "HTG";
    Currencies["HUF"] = "HUF";
    Currencies["IDR"] = "IDR";
    Currencies["ILS"] = "ILS";
    Currencies["INR"] = "INR";
    Currencies["IQD"] = "IQD";
    Currencies["IRR"] = "IRR";
    Currencies["ISK"] = "ISK";
    Currencies["JMD"] = "JMD";
    Currencies["JOD"] = "JOD";
    Currencies["JPY"] = "JPY";
    Currencies["KES"] = "KES";
    Currencies["KGS"] = "KGS";
    Currencies["KHR"] = "KHR";
    Currencies["KMF"] = "KMF";
    Currencies["KPW"] = "KPW";
    Currencies["KRW"] = "KRW";
    Currencies["KWD"] = "KWD";
    Currencies["KYD"] = "KYD";
    Currencies["KZT"] = "KZT";
    Currencies["LAK"] = "LAK";
    Currencies["LBP"] = "LBP";
    Currencies["LKR"] = "LKR";
    Currencies["LRD"] = "LRD";
    Currencies["LSL"] = "LSL";
    Currencies["LYD"] = "LYD";
    Currencies["MAD"] = "MAD";
    Currencies["MDL"] = "MDL";
    Currencies["MGA"] = "MGA";
    Currencies["MKD"] = "MKD";
    Currencies["MMK"] = "MMK";
    Currencies["MNT"] = "MNT";
    Currencies["MOP"] = "MOP";
    Currencies["MRU"] = "MRU";
    Currencies["MUR"] = "MUR";
    Currencies["MVR"] = "MVR";
    Currencies["MWK"] = "MWK";
    Currencies["MXN"] = "MXN";
    Currencies["MXV"] = "MXV";
    Currencies["MYR"] = "MYR";
    Currencies["MZN"] = "MZN";
    Currencies["NAD"] = "NAD";
    Currencies["NGN"] = "NGN";
    Currencies["NIO"] = "NIO";
    Currencies["NOK"] = "NOK";
    Currencies["NPR"] = "NPR";
    Currencies["NZD"] = "NZD";
    Currencies["OMR"] = "OMR";
    Currencies["PAB"] = "PAB";
    Currencies["PEN"] = "PEN";
    Currencies["PGK"] = "PGK";
    Currencies["PHP"] = "PHP";
    Currencies["PKR"] = "PKR";
    Currencies["PLN"] = "PLN";
    Currencies["PYG"] = "PYG";
    Currencies["QAR"] = "QAR";
    Currencies["RON"] = "RON";
    Currencies["RSD"] = "RSD";
    Currencies["RUB"] = "RUB";
    Currencies["RWF"] = "RWF";
    Currencies["SAR"] = "SAR";
    Currencies["SBD"] = "SBD";
    Currencies["SCR"] = "SCR";
    Currencies["SDG"] = "SDG";
    Currencies["SEK"] = "SEK";
    Currencies["SGD"] = "SGD";
    Currencies["SHP"] = "SHP";
    Currencies["SLL"] = "SLL";
    Currencies["SOS"] = "SOS";
    Currencies["SRD"] = "SRD";
    Currencies["SSP"] = "SSP";
    Currencies["STN"] = "STN";
    Currencies["SVC"] = "SVC";
    Currencies["SYP"] = "SYP";
    Currencies["SZL"] = "SZL";
    Currencies["THB"] = "THB";
    Currencies["TJS"] = "TJS";
    Currencies["TMT"] = "TMT";
    Currencies["TND"] = "TND";
    Currencies["TOP"] = "TOP";
    Currencies["TRY"] = "TRY";
    Currencies["TTD"] = "TTD";
    Currencies["TWD"] = "TWD";
    Currencies["TZS"] = "TZS";
    Currencies["UAH"] = "UAH";
    Currencies["UGX"] = "UGX";
    Currencies["USD"] = "USD";
    Currencies["USN"] = "USN";
    Currencies["UYI"] = "UYI";
    Currencies["UYU"] = "UYU";
    Currencies["UYW"] = "UYW";
    Currencies["UZS"] = "UZS";
    Currencies["VES"] = "VES";
    Currencies["VND"] = "VND";
    Currencies["VUV"] = "VUV";
    Currencies["WST"] = "WST";
    Currencies["XAF"] = "XAF";
    Currencies["XAG"] = "XAG";
    Currencies["XAU"] = "XAU";
    Currencies["XBA"] = "XBA";
    Currencies["XBB"] = "XBB";
    Currencies["XBC"] = "XBC";
    Currencies["XBD"] = "XBD";
    Currencies["XCD"] = "XCD";
    Currencies["XDR"] = "XDR";
    Currencies["XOF"] = "XOF";
    Currencies["XPD"] = "XPD";
    Currencies["XPF"] = "XPF";
    Currencies["XPT"] = "XPT";
    Currencies["XSU"] = "XSU";
    Currencies["XTS"] = "XTS";
    Currencies["XUA"] = "XUA";
    Currencies["XXX"] = "XXX";
    Currencies["YER"] = "YER";
    Currencies["ZAR"] = "ZAR";
    Currencies["ZMW"] = "ZMW";
    Currencies["ZWL"] = "ZWL";
})(Currencies || (exports.Currencies = Currencies = {}));
//# sourceMappingURL=currencies.enum.js.map